<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.USERS_PAGE_TITLE | translate }}</span>
</div>

<div class="row">
  <div class="c-details col">
    <div class="c-details__action-button u-mt--large">
      <div
        class="u-mobile"
        style="gap: 10px">
        <button
          routerLink="{{ routeNameConstants.ADMIN_USERS_NEW }}"
          type="button"
          class="button button-primary button-block u-mobile">
          {{ localizationConstants.USERS_CREATE | translate }}
        </button>
        <button
          (click)="createUserInAzure()"
          type="button"
          class="button button-primary button-block u-mobile">
          {{ localizationConstants.USERS_CREATE_IN_AZURE | translate }}
        </button>
      </div>
      <div class="create-buttons-big-container">
        <button
          routerLink="{{ routeNameConstants.ADMIN_USERS_NEW }}"
          type="button"
          class="button--sm button-primary u-tablet">
          {{ localizationConstants.USERS_CREATE | translate }}
        </button>
        <button
          (click)="createUserInAzure()"
          type="button"
          class="button--sm button-primary u-tablet">
          {{ localizationConstants.USERS_CREATE_IN_AZURE | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<div
  class="row u-mb-3"
  [hidden]="!dataSource.data?.length">
  <div class="col">
    <div class="col-12 col-sm-6 col-md-3 u-mb--medium">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource.filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />
          <input
            *ngIf="dataSource.filter"
            id="users-search-clear"
            (click)="dataSource.filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
          <input
            *ngIf="!dataSource.filter"
            id="users-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
        </div>
      </form>
    </div>
    <div class="u-scroll--horizontal">
      <div class="col">
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          [hidden]="!dataSource.data?.length"
          [trackBy]="trackByFn"
          class="c-table">
          <ng-container
            *ngFor="let col of columns"
            [matColumnDef]="col.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="c-table__column-title">
              {{ col.title | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let user">
              <ng-container [ngSwitch]="col.key">
                <div *ngSwitchCase="'firstName'">
                  {{ user.firstName | titlecase }} {{ user.lastName | titlecase }}
                </div>

                <div *ngSwitchCase="'email'">
                  {{ user.email }}
                </div>

                <div *ngSwitchCase="'role'">
                  {{ user.role }}
                </div>

                <div *ngSwitchCase="'companies'">
                  <!-- TODO: Move logic to controller -->
                  <div *ngIf="user.role === 'User'">
                    <div
                      class="c-chip"
                      *ngFor="let c of user.companies">
                      {{ c.fullName }}
                    </div>
                  </div>
                  <div *ngIf="user.role === 'Country User' || user.role === 'Country Admin'">
                    <div
                      class="c-chip"
                      *ngFor="let f of user.famcodes">
                      {{ f }}
                    </div>
                  </div>
                </div>

                <div *ngSwitchCase="'createDate'">
                  {{ user.createDate | date }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let user">
              <button
                [routerLink]="[routeNameConstants.ADMIN_USERS, user.userId]"
                type="button"
                class="button--sm button-primary button-block"
                [disabled]="!allowEdit(user)">
                {{ localizationConstants.BUTTON_EDIT | translate }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="action2">
            <th
              mat-header-cell
              *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let user">
              <button
                (click)="onDeleteUser(user)"
                type="button"
                class="button--sm button-secondary button-block"
                [disabled]="!allowDelete(user)">
                <app-loading-icon *ngIf="user.isItemLoading"></app-loading-icon>
                <span *ngIf="!user.isItemLoading">{{
                  localizationConstants.BUTTON_DELETE | translate
                }}</span>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columnKeysAll"></tr>
          <tr
            mat-row
            *matRowDef="let user; columns: columnKeysAll"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
